export const FEEDBACK_360_TYPE = [
    "360FeedbackDynamic",
    "360Feedback",
    "360FromScratch",
    "180FeedbackDynamic"
]

export const COMMON_ERROR_MESSAGE = "Oops! Please enter an answer"
export const ERROR_MESSAGE_FEEDBACK_TEXT = "Oops! Enter all text answers."
export const ERROR_MESSAGE_CONDITIONAL_FEEDBACK = "Please select at least 3 behaviors as Strengths and at least 3 behaviors as Improvement Areas"
export const ERROR_MESSAGE_DRAG = "Oops! Please drop into all blocks"
export const ERROR_MESSAGE_DRAG_NUMBER = "Oops! Please select at least 3 behaviors"
export const ERROR_MESSAGE_DRAG_STRENGTH = "Oops! Please select at least 3 strengths"
export const ERROR_MESSAGE_DRAG_IMPROVEMENT = "Oops! Please select at least 3 improvement areas"
export const NA_CONDITION = {
    columnValues: ["0"]
}
export const FEEDBACK_ERROR_NOT_EQUAL = (strengthNeeded, ImprovementNeeded) => `Please select at least ${strengthNeeded} Or ${ImprovementNeeded} behaviors as Strengths and at least ${strengthNeeded} Or ${ImprovementNeeded} behaviors as Improvement Areas`
export const FEEDBACK_ERROR_EQUAL = (strengthNeeded) => `Please select at least ${strengthNeeded} behaviors as Strengths and at least ${strengthNeeded} behaviors as Improvement Areas`
export const STRENGTH_VALUES = ["3", "4"]
export const IMPROVEMENT_VALUES = ["1", "2"]